"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
var Observable = /** @class */ (function () {
    function Observable() {
        this._listeners = {};
    }
    Observable.prototype.on = function (event, callback) {
        this._listeners = this._listeners || {};
        if (event in this._listeners) {
            this._listeners[event].push(callback);
        }
        else {
            this._listeners[event] = [callback];
        }
    };
    Observable.prototype.trigger = function (event, options) {
        var slice = Array.prototype.slice;
        var params = slice.call(arguments, 1);
        this._listeners = this._listeners || {};
        // Params should always come in as an array
        if (params == null) {
            params = [];
        }
        // If there are no arguments to the event, use a temporary object
        if (params.length === 0) {
            params.push({});
        }
        // Set the `_type` of the first object to the event
        params[0]._type = event;
        if (event in this._listeners) {
            this.invoke(this._listeners[event], slice.call(arguments, 1));
        }
        if ('*' in this._listeners) {
            this.invoke(this._listeners['*'], arguments);
        }
    };
    Observable.prototype.invoke = function (_listeners, params) {
        for (var i = 0, len = _listeners.length; i < len; i++) {
            _listeners[i].apply(this, params);
        }
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=observable.js.map